<div
    class="equipment-overview-card"
    [class.equipment-overview-card--collapsed]="collapsed()">
    <button
        type="button"
        class="equipment-overview-card__header"
        [attr.aria-expanded]="!collapsed()"
        (click)="toggleCollapsed()">
        <span class="equipment-overview-card__label">Equipment</span>
        @if (equipment().length > 0) {
            <span class="equipment-overview-card__count">
                {{ equipment().length }}
            </span>
        }
        <span
            nz-icon
            nzType="down"
            nzTheme="outline"
            class="equipment-overview-card__chevron"></span>
    </button>

    <div class="equipment-overview-card__body">
        @if (equipment().length === 0) {
            <div class="equipment-overview-card__empty">
                <span
                    nz-icon
                    nzType="platform-base:cart-plus-fill-duo"
                    class="equipment-overview-card__empty-icon"></span>
                <span class="equipment-overview-card__empty-text">
                    No equipment claimed
                </span>
                @if (showAddButton()) {
                    <pf-button
                        buttonType="action"
                        pfIcon="addHandlingUnit"
                        (click)="openAddHandlingUnit()">
                        Add equipment
                    </pf-button>
                }
            </div>
        } @else {
            <div class="equipment-chips-scroll">
                @for (eq of equipment(); track eq.equipment.id) {
                    <pf-chip [icon]="'info'" (click)="onEquipmentChipClick(eq)">
                        <div class="equipment-chip-overview">
                            <span>{{ eq.displayName }}</span>
                            @if (showChildCount() && eq.childCount > 0) {
                                <span class="equipment-chip-child-count">
                                    {{ eq.usedChildCount }} /
                                    {{ eq.childCount }}
                                </span>
                            }
                        </div>
                    </pf-chip>
                }
            </div>
            @if (showAddButton()) {
                <pf-button
                    class="manage-button"
                    buttonType="action"
                    pfIcon="addHandlingUnit"
                    (click)="openAddHandlingUnit()">
                    Manage
                </pf-button>
            }
        }
    </div>
</div>

<nz-drawer
    [nzClosable]="true"
    [nzVisible]="addHandlingUnitVisible()"
    nzPlacement="bottom"
    nzTitle="Add Handling Unit"
    [nzHeight]="'85vh'"
    (nzOnClose)="closeAddHandlingUnit()">
    <ng-container *nzDrawerContent>
        <div class="add-handling-unit-drawer-content">
            <cpw-equipment-scan
                [autoFocus]="true"
                [stagingZoneType]="moveToZoneType()"
                [validationRule]="validationRule()"
                (equipmentScanned)="
                    onEquipmentScanned($event)
                "></cpw-equipment-scan>

            @if (equipmentByType().length) {
                <hr class="scan-divider" />
                <div class="equipment-type-groups">
                    @for (group of equipmentByType(); track group.typeName) {
                        <section class="equipment-type-section">
                            <h3 class="type-section-heading">
                                {{ group.typeName }}
                            </h3>
                            <div class="equipment-grid">
                                @for (
                                    eq of group.items;
                                    track eq.equipment.id
                                ) {
                                    <article class="equipment-card">
                                        <header class="equipment-card__header">
                                            <span
                                                class="equipment-card__name"
                                                >{{ eq.displayName }}</span
                                            >
                                            <pf-chip [pfColor]="eq.statusColor"
                                                >{{ eq.status }}
                                            </pf-chip>
                                        </header>
                                        @if (!eq.isLtl) {
                                            <button
                                                type="button"
                                                class="equipment-card__count"
                                                (click)="
                                                    showEquipmentInfo(
                                                        eq.equipment
                                                    )
                                                ">
                                                <span>
                                                    {{ eq.usedChildCount }} /
                                                    {{ eq.childCount }} bins
                                                    used
                                                </span>
                                                <span
                                                    nz-icon
                                                    nzType="right"
                                                    nzTheme="outline"
                                                    class="equipment-card__chevron"></span>
                                            </button>
                                        }
                                        <footer class="equipment-card__actions">
                                            @if (
                                                (!eq.isLtl || canStageLtl()) &&
                                                moveToZoneType() !== null &&
                                                eq.status !== targetStatus()
                                            ) {
                                                <pf-button
                                                    buttonType="action"
                                                    (click)="
                                                        stageEquipment(
                                                            eq.equipment
                                                        )
                                                    "
                                                    >{{
                                                        moveToZoneTypeButtonText()
                                                    }}
                                                </pf-button>
                                            }
                                            @if (
                                                showRemoveButton() &&
                                                eq.isAssignedToCurrentUser
                                            ) {
                                                <pf-button
                                                    buttonType="action-delete"
                                                    (click)="
                                                        onRemove(eq.equipment)
                                                    "
                                                    >Unassign
                                                </pf-button>
                                            }
                                        </footer>
                                    </article>
                                }
                            </div>
                        </section>
                    }
                </div>

                @if (canStage()) {
                    <pf-button
                        class="stage-all-btn"
                        buttonType="submit"
                        block
                        (click)="stageAllEquipment()"
                        >{{ moveAllToZoneTypeButtonText() }}
                    </pf-button>
                }
            }
        </div>
    </ng-container>
</nz-drawer>
